<div id="payment-element">
  <!--Stripe.js injects the Payment Element-->
</div>
